import {useMutation} from '@tanstack/react-query';
import {GetValidateBankParams} from 'domain/usecases/private/refund/request/get-validate-bank';
import {validateRefundBank} from '../../services/validateRefundBank';

export function useValidateRefundBankMutation() {
	return useMutation({
		mutationFn: (params: GetValidateBankParams) => validateRefundBank(params),
	});
}
